
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export function useTwilioConfig() {
  const navigate = useNavigate();

  const goToIntegrations = () => {
    navigate('/integrations?tab=twilio');
  };

  const checkTwilioConfiguration = async () => {
    try {
      const { data, error } = await supabase.functions.invoke('twilio-integration', {
        body: { action: 'checkConfig' }
      });

      if (error || !data?.configured) {
        toast.error("Twilio credentials are not configured. Please set them up in Integrations.", {
          action: {
            label: "Configure Twilio",
            onClick: goToIntegrations
          }
        });
        return false;
      }
      return true;
    } catch (error) {
      console.warn("Error checking Twilio configuration:", error);
      return false;
    }
  };

  return {
    checkTwilioConfiguration,
    goToIntegrations
  };
}
